module.exports = __webpack_public_path__ + "static/media/galactic-senate.8718c2f0.svg";